import { Button, Text } from '@vallourec-ui/vallourec-ui'
import styled, { css } from 'styled-components'

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors['neutral-color-5']};
  width: 100%;
  align-self: stretch;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors['neutral-color-80']};
  min-height: 30rem;
  max-height: 30rem;
  padding-right: ${({ theme }) => theme.spacing[16]};
  overflow-y: auto;
  gap: 1rem;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  height: auto;
  width: 100%;
  margin-bottom: 6px;
  gap: 1.5rem;
`

export const ComponentsColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`

export const StyledText = styled(Text)`
  padding-left: ${({ theme }) => theme.spacing[6]};
  padding-bottom: ${({ theme }) => theme.spacing[0]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: ${({ theme }) => theme.fontSize['text-sm']};
`

export const ComponentsSearchColumn = styled.div<{ isLast?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-right: ${(props) =>
    props.isLast ? '0' : ({ theme }) => theme.spacing[16]};
  margin-top: ${({ theme }) => theme.spacing[8]};
  margin-bottom: ${({ theme }) => theme.spacing[16]};

  > div button {
    width: auto;
  }
`

export const CardRow = styled(Row)`
  width: 98%;
  border: 1px solid #ddd;
  align-items: center;
  border-radius: 8px;
  padding:8px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`
export const ComponentsColumnScrollable = styled(ComponentsColumn)`
  max-height: 20rem;
  overflow-y: auto;
`

type ButtonVariants =
  | 'errorWithBorders'
  
const buttonStyles = {
  errorWithBorders: css`
    background-color: ${({ theme }) => theme.colors['feedback-negative-0']};
    border: ${({ theme }) =>
      `1px solid ${theme.colors['feedback-negative-3']}`};
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      background: ${({ theme }) => theme.colors['feedback-negative-3']};
      color: ${({ theme }) => theme.colors['feedback-negative-4']};
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  `
}

export const StyledButton = styled(Button)<
  Partial<{ variant: ButtonVariants }>
>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: ${({ theme }) => theme.spacing[8]};
  padding-bottom: ${({ theme }) => theme.spacing[8]};
  white-space: nowrap;
  width: 100%;
  ${({ variant = 'errorWithBorders' }) =>
    buttonStyles[variant as ButtonVariants]}
`